// Put a build on hold with a reason (T7).
import { useState } from 'react';

import type { HoldReason } from '../../api/generated/HoldReason';
import { Button, Dialog, ErrorPanel, TextField } from '../../design/components';
import { HOLD_REASONS } from './ProblemDialog';

export function HoldDialog({
    open,
    onClose,
    onHold,
    error,
    busy,
}: {
    open: boolean;
    onClose: () => void;
    onHold: (reason: HoldReason, note: string) => void;
    error: unknown;
    busy: boolean;
}) {
    const [reason, setReason] = useState<HoldReason>('WaitingForPart');
    const [note, setNote] = useState('');
    return (
        <Dialog open={open} title="Put the build on hold" onClose={onClose}>
            <fieldset className="sf-field" style={{ border: 'none', padding: 0 }}>
                <legend style={{ fontWeight: 600 }}>Why?</legend>
                <div className="sf-outcomes">
                    {HOLD_REASONS.map((option) => (
                        <Button
                            key={option.value}
                            aria-pressed={reason === option.value}
                            onClick={() => {
                                setReason(option.value);
                            }}
                        >
                            {option.label}
                        </Button>
                    ))}
                </div>
            </fieldset>
            <TextField label="Note (optional)" value={note} onChange={setNote} multiline />
            {error ? <ErrorPanel error={error} title="The build wasn’t put on hold." /> : null}
            <div className="sf-dialog-actions">
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="danger"
                    disabled={busy}
                    onClick={() => {
                        onHold(reason, note);
                    }}
                >
                    {busy ? 'Holding…' : 'Put on hold'}
                </Button>
            </div>
        </Dialog>
    );
}
